/** Display name of the product (shown in sidebar, login, copy). Set `VITE_APP_NAME` in `.env`. */
export const APP_NAME = (import.meta.env.VITE_APP_NAME ?? '').trim() || 'Kartly'

/** English possessive for short phrases, e.g. "Acme's" */
export function appPossessive(): string {
  return /s$/i.test(APP_NAME) ? `${APP_NAME}'` : `${APP_NAME}'s`
}
